"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuTxtTranslit = void 0;
const ui_1 = require("@jsonjoy.com/ui");
const TranslitService_1 = require("../../translit/TranslitService");
const TranslitMenu_1 = require("./TranslitMenu");
class MuTxtTranslit extends TranslitService_1.TranslitService {
    constructor() {
        super(...arguments);
        this.menu = new TranslitMenu_1.TranslitMenu(this);
        this.mapOpen = ui_1.rsync.val(null);
        this.openMap = (id) => {
            const target = id ?? this.active.value ?? this.lastUsed.value ?? this.list()[0]?.id ?? null;
            this.mapOpen.set(target);
        };
        this.closeMap = () => {
            this.mapOpen.set(null);
        };
    }
    bindState(state) {
        this.state = state;
    }
    start() {
        return this.menu.start();
    }
}
exports.MuTxtTranslit = MuTxtTranslit;
